<mojo-candidate-profile-card
  [candidate]="candidate"
  [privileges]="privileges"
>
</mojo-candidate-profile-card>
<mojo-nav-left [pages]="pages"> </mojo-nav-left>
